import React, { useState } from 'react';
import ReactDom from 'react-dom/client';
import AppLayout from '../components/AppMenu/AppLayout';
import { WelcomeScreenCard } from '../components/WelcomeScreenCard';
import WelcomeScreenAnonymousUser from './WelcomeScreenAnonymousUser';
import SelectCashGameModal from './cashGames/modals/SelectCashGameModal';
import LogoTextWelScreen from '../components/Icons/LogoTextWelScreen';
import MediaQuery from 'react-responsive';
import WelcomeScreenIcon from '../components/Icons/WelcomeScreenIcon';

const WrapperCard = (props) => {
  return (
    <a
      href={props.href}
      onClick={props.onClick}
      className="flex items-center justify-center w-full max-w-[650px] mx-[25px] py-[15px] min-h-[110px] hover:bg-[#191E2B] active:bg-[#0046FA] rounded-[8px] pr-[20px] min-[500px]:pr-[40px]"
    >
      <div className="flex items-center justify-center h-full px-[20px] min-[500px]:px-[50px]">
        {props?.icon}
      </div>
      <div className="flex flex-col items-start justify-start w-full">
        <p className="heading-3-n mb-[8px]"> {props.title}</p>
        <p className="regular-12 min-[500px]:text-[14px] pr-[20px] min-[500px]:pr-[40px]">
          {props.text}
        </p>
      </div>
    </a>
  );
};

const content = [
  {
    variant: 'cash',
    title: 'Create a Cash Table',
    text: 'Set a private cash table, customize the game settings and share the table URL with your friends'
  },
  {
    variant: 'mtt',
    title: 'Create a Multi-table tournament',
    text: 'Set-up your own private or public tournament. Customize the tournament settings, add your logo to the table felt and compete against a large'
  },
  {
    variant: 'createClub',
    title: 'Create a Club',
    text: 'Quickly set-up your own private club page, add your club description, and set-up custom conditions players need to meet to join'
  },
  {
    variant: 'joinClub',
    title: 'Join a Club',
    text: 'View and join anyclub created by other communities on the platform'
  },
  {
    variant: 'gameLobby',
    title: 'View our Game Lobby',
    text: 'View and join any cash table or tournament other players have created and posted in our shared lobby'
  },
  {
    variant: 'practice',
    title: 'Practic against our Poker Bots',
    text: 'Hone your skills against our poker bots on a cash table'
  }
];

export default function WelcomeScreen() {
  const [show, setShow] = useState(false);
    const viewToShow = !show ? <div className="w-full">
      <div
        className="mt-[40px] min-[500px]:mt-[80px] flex
       h-full w-full flex-col items-center justify-center text-[20px]
      text-white max-lg:justify-start px-[25px]"
      >
        <div className="w-full max-w-[650px] mt-[25px] mb-[20px] min-[500px]:my-[25px] flex items-start justify-start">
          <MediaQuery minWidth={500}>
            <LogoTextWelScreen mobile={false} />
          </MediaQuery>
          <MediaQuery maxWidth={499}>
            <LogoTextWelScreen mobile={true} />
          </MediaQuery>
        </div>
        <div
          className="regular-12 w-full max-w-[650px] mb-[20px] flex items-start justify-start 
          min-[500px]:text-[20px] min-[500px]:leading-[23px] min-[500px]:my-[20px]"
        >
          The home of poker communities from around the world
        </div>
        <div
          className="text-[14px] leading-[16.1px] min-[500px]:text-[20px] min-[500px]:leading-[23px] 
          font-semibold w-full max-w-[650px] mb-[20px] flex items-start justify-start"
        >
          What would you like to do today?
        </div>
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[0].variant} />}
          title={content[0].title}
          text={content[0].text}
          href="#"
          onClick={() => setShow(true)}
        />
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[1].variant} />}
          title={content[1].title}
          text={content[1].text}
          href="/tournament/create"
        />
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[2].variant} />}
          title={content[2].title}
          text={content[2].text}
          href="/clubs/create"
        />
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[3].variant} />}
          title={content[3].title}
          text={content[3].text}
          href="/clubs/lobby"
        />
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[4].variant} />}
          title={content[4].title}
          text={content[4].text}
          href="/lobby"
        />
        <WrapperCard
          icon={<WelcomeScreenIcon variant={content[5].variant} />}
          title={content[5].title}
          text={content[5].text}
          href="/learn"
        />
      </div>
    </div>
    :  <SelectCashGameModal show={show} setShow={setShow} />;
  return viewToShow;
}

const root = ReactDom.createRoot(document.getElementById('react'));

root.render(
  <AppLayout className="!h-full">
    {global.props?.user?.is_authenticated ? <WelcomeScreen /> : <WelcomeScreenAnonymousUser />}
  </AppLayout>
);
